import { render } from "./FidDog.vue?vue&type=template&id=bded2ae2"
const script = {}

import exportComponent from "C:\\Users\\marcelo.santos.admin\\repos\\Fidelidade\\Fidelidade-Ciclos-Restaurantes\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__